import React from 'react';

function Devis() {
  return (
    <div>
      <h1 className="text-3xl font-bold text-blue-700 mb-4">Mes Devis</h1>
      <p className="text-gray-600">Ici s'afficheront tes devis !</p>
    </div>
  );
}

export default Devis;
